module.exports = __webpack_public_path__ + "img/status-DELETED-icon.426de37b.svg";